import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "bg-white px-8 pt-4 pb-2" };
const _hoisted_2 = { class: "flex items-center gap-3" };
const _hoisted_3 = {
    key: 0,
    class: "text-xs text-green-600 font-medium flex items-center"
};
const _hoisted_4 = {
    key: 0,
    class: "space-y-3"
};
const _hoisted_5 = {
    key: 0,
    class: "flex gap-2 mt-2"
};
const _hoisted_6 = ["placeholder", "disabled"];
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
    key: 0,
    class: "fas fa-spinner fa-spin"
};
const _hoisted_9 = { key: 1 };
const _hoisted_10 = {
    key: 1,
    class: "space-y-2"
};
const _hoisted_11 = { class: "flex items-center justify-between p-3 bg-green-50 border border-green-200 rounded-lg" };
const _hoisted_12 = { class: "flex-1" };
const _hoisted_13 = { class: "flex items-center gap-2 mb-1" };
const _hoisted_14 = { class: "text-sm font-semibold text-green-800" };
const _hoisted_15 = { class: "px-2 py-0.5 bg-green-600 text-white text-xs font-mono rounded" };
const _hoisted_16 = { class: "text-xs text-green-700" };
const _hoisted_17 = {
    key: 0,
    class: "text-xs text-green-700 mt-1"
};
const _hoisted_18 = {
    key: 0,
    class: "flex justify-between items-center text-sm px-1"
};
const _hoisted_19 = { class: "font-semibold text-green-600" };
const _hoisted_20 = {
    key: 3,
    class: "flex items-start gap-2 p-2 bg-blue-50 border border-blue-200 rounded-lg"
};
import { ref, computed, watch } from 'vue';
import { useTheme } from '@shared/composables/useTheme';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DiscountCodeInput',
    props: {
        modelValue: { default: '' },
        discountInfo: { default: null },
        isValidating: { type: Boolean, default: false },
        errorMessage: { default: '' },
        placeholder: { default: 'Code eingeben' },
        fromUrl: { type: Boolean, default: false }
    },
    emits: ["update:modelValue", "apply", "remove", "clearError"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Toggle state - default geschlossen
        const isOpen = ref(false);
        const { theme } = useTheme();
        const discountErrorColor = computed(() => theme.value.colors.danger || theme.value.colors.primary);
        const discountErrorStyle = computed(() => ({
            backgroundColor: `${discountErrorColor.value}12`,
            borderColor: `${discountErrorColor.value}55`
        }));
        const localCode = ref(props.modelValue || '');
        // Watch for external changes to modelValue
        watch(() => props.modelValue, (newValue) => {
            if (newValue !== localCode.value) {
                localCode.value = newValue || '';
            }
        });
        // Auto-open when discount is applied
        watch(() => props.discountInfo, (newInfo) => {
            if (newInfo && newInfo.isValid) {
                isOpen.value = true;
            }
        });
        const discountApplied = computed(() => props.discountInfo && props.discountInfo.isValid);
        const canApply = computed(() => localCode.value.trim().length > 0 &&
            !props.isValidating &&
            !discountApplied.value);
        const handleInput = () => {
            // Convert to uppercase and limit to 30 characters
            let sanitized = localCode.value.toUpperCase().slice(0, 30);
            // Remove special characters except letters, numbers, and hyphens
            sanitized = sanitized.replace(/[^A-Z0-9-]/g, '');
            localCode.value = sanitized;
            emit('update:modelValue', sanitized);
            // Clear error when user types
            if (props.errorMessage) {
                emit('clearError');
            }
        };
        const handleApply = () => {
            if (canApply.value) {
                const code = localCode.value.trim();
                if (code) {
                    emit('apply', code);
                }
            }
        };
        const handleRemove = () => {
            localCode.value = '';
            emit('update:modelValue', '');
            emit('remove');
        };
        const toggleSection = () => {
            isOpen.value = !isOpen.value;
        };
        const formatPrice = (value) => {
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: 'EUR'
            }).format(value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createCommentVNode(" Header mit Toggle "),
                _createElementVNode("div", {
                    onClick: toggleSection,
                    class: "flex justify-between items-center cursor-pointer hover:bg-gray-50 rounded-lg p-2 -m-2 transition-colors duration-200"
                }, [
                    _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 flex items-center" }, [
                        _createElementVNode("i", { class: "fas fa-tag mr-2 text-gray-600" }),
                        _createTextVNode(" Rabattcode ")
                    ], -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_2, [
                        (discountApplied.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("i", { class: "fas fa-check-circle mr-1" }, null, -1 /* CACHED */),
                                    _createTextVNode(" Angewendet ", -1 /* CACHED */)
                                ]))]))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("i", {
                            class: _normalizeClass([isOpen.value ? 'fas fa-chevron-up' : 'fas fa-chevron-down', "text-gray-600 text-sm transition-transform duration-200"])
                        }, null, 2 /* CLASS */)
                    ])
                ]),
                _createCommentVNode(" Collapsible Content "),
                (isOpen.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createCommentVNode(" Input Field "),
                        (!discountApplied.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localCode).value = $event)),
                                    type: "text",
                                    maxlength: "30",
                                    placeholder: _ctx.placeholder,
                                    disabled: _ctx.isValidating,
                                    class: "flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed text-sm text-gray-900 uppercase transition-all",
                                    onKeyup: _withKeys(handleApply, ["enter"]),
                                    onInput: handleInput
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_6), [
                                    [_vModelText, localCode.value]
                                ]),
                                _createElementVNode("button", {
                                    onClick: handleApply,
                                    disabled: !canApply.value,
                                    class: _normalizeClass(["apply-button px-4 py-2 rounded-lg font-medium text-sm transition-all duration-300", canApply.value
                                            ? 'bg-primary-600 text-white hover:bg-primary-700 shadow-sm hover:shadow-md'
                                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'])
                                }, [
                                    (_ctx.isValidating)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_9, "Anwenden"))
                                ], 10 /* CLASS, PROPS */, _hoisted_7)
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Applied Discount Info "),
                        (discountApplied.value && _ctx.discountInfo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.discountInfo.name), 1 /* TEXT */),
                                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.discountInfo.code), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.discountInfo.description || 'Rabatt aktiv'), 1 /* TEXT */),
                                        (_ctx.discountInfo.minimumOrderValueCent && _ctx.discountInfo.minimumOrderValueCent > 0)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Mindestbestellwert: " + _toDisplayString(formatPrice(_ctx.discountInfo.minimumOrderValueCent / 100)), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _createElementVNode("button", {
                                        onClick: handleRemove,
                                        class: "ml-3 p-2 text-green-700 hover:text-green-900 hover:bg-green-100 rounded-lg transition-colors",
                                        title: "Rabatt entfernen"
                                    }, [...(_cache[3] || (_cache[3] = [
                                            _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */)
                                        ]))])
                                ]),
                                _createCommentVNode(" Discount Amount "),
                                (_ctx.discountInfo.amountEuro)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-gray-600" }, "Ersparnis:", -1 /* CACHED */)),
                                        _createElementVNode("span", _hoisted_19, "-" + _toDisplayString(formatPrice(_ctx.discountInfo.amountEuro || 0)), 1 /* TEXT */)
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Error Message "),
                        (_ctx.errorMessage && !discountApplied.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "flex items-start gap-2 p-2 border rounded-lg",
                                style: _normalizeStyle(discountErrorStyle.value)
                            }, [
                                _createElementVNode("i", {
                                    class: "fas fa-exclamation-circle mt-0.5",
                                    style: _normalizeStyle({ color: discountErrorColor.value })
                                }, null, 4 /* STYLE */),
                                _createElementVNode("p", {
                                    class: "text-xs flex-1",
                                    style: _normalizeStyle({ color: discountErrorColor.value })
                                }, _toDisplayString(_ctx.errorMessage), 5 /* TEXT, STYLE */)
                            ], 4 /* STYLE */))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" URL Discount Info "),
                        (_ctx.fromUrl && discountApplied.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[5] || (_cache[5] = [
                                    _createElementVNode("i", { class: "fas fa-info-circle text-blue-500 mt-0.5" }, null, -1 /* CACHED */),
                                    _createElementVNode("p", { class: "text-xs text-blue-700" }, "Dieser Rabattcode wurde automatisch aus dem Link angewendet.", -1 /* CACHED */)
                                ]))]))
                            : _createCommentVNode("v-if", true)
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
